import { render, staticRenderFns } from "./StatSummary.vue?vue&type=template&id=be78709c&scoped=true&"
import script from "./StatSummary.vue?vue&type=script&lang=js&"
export * from "./StatSummary.vue?vue&type=script&lang=js&"
import style0 from "./StatSummary.vue?vue&type=style&index=0&id=be78709c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be78709c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be78709c')) {
      api.createRecord('be78709c', component.options)
    } else {
      api.reload('be78709c', component.options)
    }
    module.hot.accept("./StatSummary.vue?vue&type=template&id=be78709c&scoped=true&", function () {
      api.rerender('be78709c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatSummary.vue"
export default component.exports